var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountTree = function SvgAccountTree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.25 20.75v-3h-4v-10h-2.5v3h-6.5v-7.5h6.5v3h6.5v-3h6.5v7.5h-6.5v-3h-2.5v8.5h2.5v-3h6.5v7.5zm1.5-11.5h3.5v-4.5h-3.5zm0 10h3.5v-4.5h-3.5zm-13-10h3.5v-4.5h-3.5z"
  })));
};
export default SvgAccountTree;